export enum AdyenEnvironment {
  Test = "test",
  Live = "live",
}
